import React from 'react';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import { capitalizeFirstLetter, translateLocale } from '../../../../../attendee/detail/components/utils';

import { Card, Initials } from '@weezevent/nacre';

import Style from '../../moderationProfile.module.css';

export default function ModerationProfileGeneralInformations({ attendee, order }) {
    const { t } = useTranslation();
    const locale = i18n.language;

    return (
        <Card id="general" className={`${Style['attendee-card']} ${Style['attendee-attendeeInfos']}`}>
            <div className={Style['attendee-attendeeInfos-cardHeader']}>
                <div className={Style['attendee-attendeeInfos-nameStatusContainer']}>
                    <div className={Style['attendee-attendeeInfos-nameContainer']}>
                        <Initials content={attendee.attendeeResolvedName} size="big" className={Style['attendee-attendeeInfos-cardHeader-initials']} />
                        <b>{attendee.attendeeResolvedName}</b>
                    </div>
                    <span>
                        <b>{t('ticket.moderation.attendee.generalInformations.moderation')} </b>
                        {attendee.status.name}
                    </span>
                </div>
                {!attendee.event_spam_moderation && (
                    <>
                        <span className={Style['attendee-attendeeInfos-greyTitle']}>{t('ticket.moderation.attendee.generalInformations.rate')}</span>
                        <b>{attendee.rate_name}</b>
                    </>
                )}
            </div>

            {order.locale && !attendee.event_spam_moderation && (
                <div className={Style['attendee-attendeeInfos-section']}>
                    <b className={Style['attendee-attendeeInfos-miniTitle']}>{t('ticket.moderation.attendee.generalInformations.additionalInfos')}</b>
                    <span className={Style['attendee-attendeeInfos-greyTitle']}>{t('ticket.moderation.attendee.generalInformations.language')}</span>
                    <b>{`${capitalizeFirstLetter(translateLocale(locale, order.locale?.split('_')[1]))} (${order.locale?.split('_')[1]?.toUpperCase()})`}</b>
                </div>
            )}

            {attendee.spam_reason && attendee.event_spam_moderation && (
                <>
                    <hr className={Style['attendee-attendeeInfos-dottedSeparator']} />
                    <div className={Style['attendee-attendeeInfos-section']}>
                        <span className={Style['attendee-attendeeInfos-greyTitle']}>{t('ticket.moderation.attendee.generalInformations.spamReason')}</span>
                        <b>{attendee.spam_reason}</b>
                    </div>
                </>
            )}

            {!attendee.event_spam_moderation && (
                <>
                    <hr className={Style['attendee-attendeeInfos-dottedSeparator']} />
                    <div className={Style['attendee-attendeeInfos-section']}>
                        <span className={Style['attendee-attendeeInfos-greyTitle']}>{t('ticket.moderation.attendee.generalInformations.barcode')}</span>
                        <b>{attendee.barcode}</b>

                        {attendee.id_weez_ticket && <p>N°{attendee.id_weez_ticket}</p>}
                    </div>
                </>
            )}
        </Card>
    );
}
